module.exports = __webpack_public_path__ + "static/media/软件.4df24409.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/软件.png
// module id = 1721
// module chunks = 174